import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Projects from "./components/Projects";
import Testimonials from "./components/Testimonials";
import Pricing from "./components/Pricing";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import AdminDashboard from "./components/AdminDashboard";
import Platforms from "./components/Platforms";
import NotFound from "./components/NotFound";
import CookieBanner from "./components/CookieBanner";
import Seo from "./components/Seo";
import ProductsSection from "./components/ProductsSection";
import IndustryFinder from "./components/IndustryFinder";
import ProductPage from "./components/ProductPage";
import { ContentProvider } from "./context/ContentContext";
import { LanguageProvider } from "./context/LanguageContext";

const HomePage = () => {
  const [showPrivacyFromBanner, setShowPrivacyFromBanner] = useState(false);
  
  return (
    <>
      <Header />
      <main>
        <Hero />
        <IndustryFinder />
        <ProductsSection />
        <Services />
        <Projects />
        <Testimonials />
        <Pricing />
        <Contact />
      </main>
      <Footer showPrivacyExternal={showPrivacyFromBanner} onPrivacyClose={() => setShowPrivacyFromBanner(false)} />
      <CookieBanner onShowPrivacy={() => setShowPrivacyFromBanner(true)} />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <ContentProvider>
          <BrowserRouter>
            <Seo />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/invictacare" element={<ProductPage productId="care" />} />
              <Route path="/invictafit" element={<ProductPage productId="fit" />} />
              <Route path="/invictadance" element={<ProductPage productId="dance" />} />
              <Route path="/invictabeauty" element={<ProductPage productId="beauty" />} />
              <Route path="/invictadental" element={<ProductPage productId="dental" />} />
              <Route path="/invictaauto" element={<ProductPage productId="auto" />} />
              <Route path="/plattformen" element={<Platforms />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </ContentProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
